import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from "../../services/authentication.service";
import {TemplateService} from '../../services/template.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';
import {SelectItem} from "primeng/api";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [TemplateService]
})
export class SearchComponent implements OnInit {
  itemsPerPage = 40;

  selectedCustomercode: SelectItem[];
  customercode: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  allDeliverycode = true;
  allDocType = true;
  deliverycode: any;
  selectedDeliverycode: SelectItem[];
  allDeliverycodeList: any = null;
  deliverycodeSuggest: any;
  deliverycodeList: any = null;
  docTypeList: any = null;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allDeliverycodeSelected = [];
  rdDocumentType: any;
  selectedRdDocumentType: any;
  customercode_all: any;
  selectedType: any;
  inputText: any;
  tableData: any;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  totalItems: number = 0;
  selectedValues = [];
  selectedForShow = [];
  currentPage = 1;
  checked = false;
  url: any;
  date: Date;
  docTypes: any;
  loading = false;
  loadingZip = false;
  errorMsg = '';
  sendEmailSmsValues = [];
  defaultLabel = null;
  checkAll = false;

  calendarLocale = CALENDAR_LOCALE.TH;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  loading_all_zip_progress: number = 0;
  tableArray = [];

  modal: NgbModalRef;
  allZipCount: number;
  allZipCurrent = 0;

  sortBy: string;
  sortMode: string;

  tableCol = [
    {field: 'invoice_number', header: 'เลขที่เอกสาร'},
    {field: 'header_issue_date', header: 'วันที่ออกเอกสาร'},
    {field: 'branch', header: 'ชื่อสาขา'},
    {field: 'rd_doc_type', header: 'ประเภทเอกสาร'},
    // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
    {field: 'total_items_total_payment', header: 'ยอดขาย'}
  ];

  constructor(private apiService: ApiService,
              private authService: AuthenticationService,
              private modalService: NgbModal,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    // this.loadInput();
    // this.loadDropdown();
    this.rdDocumentType = this.template.getDropdown();
  }

  loadTexts() {
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      const documentTypeData = this.template.getDropdown();
      // documentTypeData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.rdDocumentType = documentTypeData;
      this.loadInput();
      this.tableCol.push(
        {field: 'customer_code', header: this.translate.instant('FILTER.CUSTOMER-CODE')},
        {field: 'delivery_code', header: this.translate.instant('FILTER.DELIVERY-CODE')},
        {field: 'header_issue_date', header: this.translate.instant('FILTER.DATE-OF-ISSUE')},
        {field: 'invoice_number', header: this.translate.instant('FILTER.DOCUMENT-NUMBER')},
        {field: 'goods_issue_number', header: this.translate.instant('FILTER.GOODS-ISSUE-NUMBER')},
        {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
        {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
        // { field: 'buyer_name', header: 'ชื่อผู้ซื้อ' },
        {field: 'total_items_total_payment', header: this.translate.instant('TABLE.SALES')},
        {field: 'latest_sent_time', header: this.translate.instant('FILTER.LATEST-SENT')}
      );
      this.tableCol = _.uniqBy(this.tableCol, 'field');
    });
  }

  loadInput() {
    this.selectedCustomercode = null;
    this.customercode = null;
    this.selectedRdDocumentType = null;
    this.customercode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    let params = new HttpParams();
    params = params.append('none_pagination', 'true')
    this.apiService.getCustomerList(params).subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.customercode.push({
            label: `${obj.c_code} (${obj.c_name})`,
            value: obj.id
          })
        });
        this.customercode = _.uniqBy(this.customercode, 'label');
      },
      error => error(status)
    )

    this.homeproGroup = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompanyGroup().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          })
        });
      }
    );

    this.apiService.getDeliveryList().subscribe(
      (result) => {
        this.allDeliverycodeList = result;
        this.filterDeliverycodeList();
      }
    );

    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (2020 - 1) + ':' + (thisYear);
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  filterDeliverycodeList() {
    this.selectedDeliverycode = null;
    this.deliverycodeList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allDeliverycodeList, (obj) => {
      if (this.selectedCustomercode == null || obj.d_custcode == this.selectedCustomercode)
        this.deliverycodeList.push({
          label: obj.d_code,
          value: obj.id
        })
    });
  }

  searchDeliverycode(event) {
    if (this.deliverycodeList == null) {
      this.apiService.getDeliveryList().subscribe(
        (data) => {
          this.deliverycodeList = data;
          this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
        }
      )
    } else {
      this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.apiService.getDocumentType().subscribe(
        (result) => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList)
        }
      )
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList)
    }
  }

  selectAllDeliverycode() {
    this.deliverycode = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  clearDeliverycode() {
    this.allDeliverycodeSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    let filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      let data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  loadDropdown() {
    this.docTypes = this.template.getDropdown();
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.checkAll = false;
    this.loadData(params);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearSearch() {
    this.selectedType = null;
    this.inputText = null;
    this.selectedCustomercode = null;
    this.selectedHomeproGroup = null;
    this.deliverycode = null;
    this.documentType = null;
    this.allDocType = true;
    this.allDeliverycode = true;
    this.selectedDeliverycode = null;
    this.rdDocumentType = null;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();

    this.searchButtonClicked();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadData();
  }

  loadData(params?) {
    this.checkCondition();

    if (this.errorMsg.length > 0)
      return;

    this.allDeliverycodeSelected = [];
    this.allDocumentType = [];
    _.forEach(this.deliverycode, (data) => {
      // this.allBranchSelected = [];
      this.allDeliverycodeSelected.push(_.toNumber(data.id))
    });
    _.forEach(this.documentType, (data) => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(data.id))
    });

    const data = {
      rd_doc_type: this.selectedRdDocumentType,
      search_box: this.inputText,
      header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
      group_id: this.selectedHomeproGroup,
      customercode_id: this.selectedCustomercode,
      document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
      //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      // deliverycode_id: this.selectedDeliverycode ? [this.selectedDeliverycode] : null,
      deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
      items_per_page: this.itemsPerPage
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.loading = true;
    this.apiService.postSearch(data, params).subscribe(
      (res: any) => {
        res.results = _.orderBy(res.results, ['header_issue_dt', function (o) {

          if (o.rd_document_type === 'receipt') {
            return 1;
          }
          if (o.rd_document_type === 'tax_invoice') {
            return 0;
          }
          if (o.rd_document_type === 'credit_note') {
            return 2;
          }
          if (o.rd_document_type === 'debit_note') {
            return 3;
          }

        }], ['desc', 'asc']);
        this.tableData = res.results;
        this.totalItems = res.count;
        this.selectedValues = [];
        this.sendEmailSmsValues = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.selectedValues.push(false);
        }
        this.loading = false;
      }
    );
  }

  sendEmail(email_id, index) {
    this.loading = true;
    const data = {
      'tax_id': email_id
    };
    console.log('send');
    this.apiService.send_email_web(data).subscribe(res => {
        console.log(res);
        if (res === 'OK') {
          this.tableData[index].emailtosend_taxdata_id = null;
          this.loading = false;
        } else {
          this.loading = false;
        }
        this.searchButtonClicked();
      },
      error => {
        console.log('this is error', error);
      }
    );
    this.searchButtonClicked();

  }

  DownloadSelected(content, doc_type) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i])
        continue;

      this.tableArray.push(this.tableData[i]);
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;

      if (doc_type === 'xml')
        this.download(0, this.tableArray, 'xml_file');
      else
        this.download(0, this.tableArray, 'pdf_file');
    }
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select == true).length > 0
  }

  download(index, tableArray, url_field_name) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message = 'Download ' + this.translate.instant('COMMON.COMPLETE') + ' (' + this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' + this.translate.instant('COMMON.ITEMS') + ')';
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const download_url = tableArray[index][url_field_name];

    //skip if download url is empty.
    if (download_url == null || download_url.length == 0) {
      this.download(index + 1, tableArray, url_field_name);
      return;
    }

    this.apiService.downloadFileFromMediaPath(download_url).subscribe(
      (obj) => {
        if (this.cancel_loading_all_zip) {
          return;
        }

        // this.loading_all_zip = false;
        let filename = this.getFileName(tableArray[index]);

        if (url_field_name == 'xml_file')
          filename = filename + '.xml';
        else
          filename = filename + '.pdf';

        this.apiService.createDownloadFile(obj, filename);
        this.allZipCurrent++;
        this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
        // data.xmlLoading = false;
        setTimeout(() => {
          this.download(index + 1, tableArray, url_field_name);
        }, 1000);

        // tslint:disable-next-line:max-line-length
        this.apiService.triggerLog({'log_type': 'DOWNLOAD_PDF', 'action_issue': 'DOCUMENT_SEARCH', 'description': `download ${url_field_name} invoice number ${tableArray[index].header_invoice_number}`}).subscribe();
      },
      error => {
        this.loading_all_zip = false;
        this.loading_all_zip_message = this.translate.instant('ERROR.TRY-AGAIN');
        // data.xmlLoading = false;
      }
    )
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  getFileName(data) {
    let file_name = '' + data.header_invoice_number + '_' + data.rd_document_type + '_' + data.header_issue_dt;
    file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
    return file_name
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      this.checkAll = true;
      return;
    }
    this.deselectAll();
    this.checkAll = false;
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = true;
    }
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = false;
    }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'desc';
    } else {
      this.sortMode = 'asc';

    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    let errorMsgList = [];
    if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
      errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
      return;
    }

    let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
    if (dayDiff > 60 && this.authService.isAccountant()) {
      this.errorMsg = this.translate.instant('FILTER.ERROR.DIFF');
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts